/**
 * R1's favorite teams row. `/profile/get-for-account` returns only
 * `favoriteTeamIds: string[]`, so each id is resolved through its own
 * `FanTeamPlate`.
 */
import type { ReactNode } from "react";

import { FAVORITE_TEAMS_TITLE, TEAMS_EMPTY } from "./fanProfileCopy";
import { FanTeamPlate } from "./FanTeamPlate";

export type typeFanFavoriteTeamsRowProps = {
  teamIds: readonly string[];
  testId?: string | undefined;
};

export const FanFavoriteTeamsRow = (
  props: typeFanFavoriteTeamsRowProps,
): ReactNode => (
  <section
    className="flex flex-col gap-3 rounded-lg border border-line bg-surface p-4"
    data-testid={props.testId}
  >
    <h2 className="text-h2 text-ink">{FAVORITE_TEAMS_TITLE}</h2>
    {props.teamIds.length === 0 ? (
      <p className="text-body text-ink-secondary" data-testid="fan-teams-empty">
        {TEAMS_EMPTY}
      </p>
    ) : (
      <ul className="flex flex-wrap gap-4" data-testid="fan-teams">
        {props.teamIds.map((id) => (
          <li key={id}>
            <FanTeamPlate teamId={id} />
          </li>
        ))}
      </ul>
    )}
  </section>
);
